import React from "react";
import { Skeleton } from "@mui/material";

import { useTranslation } from "@helpers/translate";
import HistoryIdIcon from "@assets/icons/HistoryIdIcon.jsx";

import {
  formatWalletTxDateTime,
  formatWalletTxBonusDisplay,
} from "../../../../../helpers/walletTxFormat";
import { getWalletTxStatusModifier } from "../../../../../helpers/walletTxStatus";

import "./WalletTxDesktopTable.sass";

const WalletTxDesktopTable = ({ data, loading }) => {
  const { __ } = useTranslation();

  const typeLabel = (el) =>
    el.operation === "deposit"
      ? __("wallet.deposit_type")
      : __("wallet.withdraw_type");

  return (
    <div className="wallet-tx-table__desktop">
      <table className="wallet-tx-table__grid">
        <thead>
          <tr>
            <th scope="col">{__("wallet.history_table.id")}</th>
            <th scope="col">{__("common.date")}</th>
            <th scope="col">{__("common.amount")}</th>
            <th scope="col">{__("common.method")}</th>
            <th scope="col">{__("common.type")}</th>
            <th scope="col">{__("common.status")}</th>
            <th scope="col">{__("wallet.history_table.bonus_amount")}</th>
          </tr>
        </thead>

        <tbody>
          {loading
            ? [1, 2, 3].map((item) => (
                <tr key={item} className="wallet-tx-table__row-skeleton">
                  <td colSpan={7}>
                    <Skeleton
                      className="table__skeleton"
                      variant="rounded"
                      height={40}
                      sx={{ width: "100%" }}
                    />
                  </td>
                </tr>
              ))
            : data.map((el) => (
                <tr key={el.id} className="wallet-tx-table__row">
                  <td>
                    <span className="wallet-tx-table__id-cell">
                      <HistoryIdIcon />
                      {el.id}
                    </span>
                  </td>

                  <td className="wallet-tx-table__cell-muted">
                    {formatWalletTxDateTime(el.created_at)}
                  </td>

                  <td>
                    {el.amount} {el.currency}
                  </td>

                  <td>{el.gateway_title || "—"}</td>

                  <td>{typeLabel(el)}</td>

                  <td>
                    <div
                      className={`wallet-tx-status-badge wallet-tx-status-badge--${getWalletTxStatusModifier(
                        el.status,
                      )}`}
                    >
                      {el.status}
                    </div>
                  </td>

                  <td className="wallet-tx-table__cell-numeric">
                    {formatWalletTxBonusDisplay(el.bonus_amount, el.currency)}
                  </td>
                </tr>
              ))}
        </tbody>
      </table>
    </div>
  );
};

export default WalletTxDesktopTable;
